<script>
export default {
  name: 'RoomCard',
  props: {
    room: {
      type: Object,
      required: true,
      validator: room => !!room.name,
    },
  },
};
</script>

<template>
  <div
    class="bg-white dark:bg-slate-800 dark:text-white p-5 rounded-lg shadow-md border border-slate-200 dark:border-slate-700"
  >
    <div class="flex items-center gap-4">
      <div
        class="flex-shrink-0 h-10 w-10 rounded-lg bg-primary-50 dark:bg-primary-900 flex items-center justify-center"
      >
        <fluent-icon icon="door" class="h-6 w-6 text-primary" />
      </div>
      <h4
        class="text-lg font-semibold text-slate-800 dark:text-white truncate"
        :title="room.name"
      >
        {{ room.name }}
      </h4>
    </div>
  </div>
</template>
